const UNSAFE_KEYS = new Set(['__proto__', 'constructor', 'prototype']);

export function resolveEntityValue(
  entity: Record<string, unknown>,
  key?: string,
): string | undefined {
  if (!key) return undefined;

  let current: unknown = entity;
  for (const part of key.split('.')) {
    if (current == null || UNSAFE_KEYS.has(part)) {
      return undefined;
    }
    current = (current as Record<string, unknown>)[part];
  }

  return typeof current === 'string' ? current : undefined;
}
